var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.8332C5 15.0587 5 14.6715 5.06405 14.3495C5.32707 13.0272 6.36073 11.9936 7.68303 11.7306C8.00503 11.6665 8.39223 11.6665 9.16667 11.6665H20H30.8333C31.6078 11.6665 31.995 11.6665 32.317 11.7306C33.6393 11.9936 34.673 13.0272 34.936 14.3495C35 14.6715 35 15.0587 35 15.8332C35 16.6076 35 16.9948 34.936 17.3168C34.673 18.6392 33.6393 19.6728 32.317 19.9358C31.995 19.9998 31.6078 19.9998 30.8333 19.9998H20H9.16667C8.39223 19.9998 8.00503 19.9998 7.68303 19.9358C6.36073 19.6728 5.32707 18.6392 5.06405 17.3168C5 16.9948 5 16.6076 5 15.8332Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 20V26.6667C6.66669 29.8093 6.66669 31.3807 7.643 32.357C8.6193 33.3333 10.1907 33.3333 13.3334 33.3333H15H25H26.6667C29.8094 33.3333 31.3807 33.3333 32.357 32.357C33.3334 31.3807 33.3334 29.8093 33.3334 26.6667V20",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.6665V33.3332",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9588 10.3653L15.6598 6.24157C14.4187 4.69022 12.1017 4.56509 10.6969 5.96991C8.597 8.06979 10.0777 11.6668 13.0474 11.6668H18.3333C19.005 11.6668 19.3785 10.8898 18.9588 10.3653Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0411 10.3653L24.3401 6.24157C25.5813 4.69022 27.8983 4.56509 29.3031 5.96991C31.403 8.06979 29.9223 11.6668 26.9526 11.6668H21.6666C20.995 11.6668 20.6215 10.8898 21.0411 10.3653Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.7cdcb4dbb424361caf4546af810273b1.svg";
export { ForwardRef as ReactComponent };